var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCalendarLg = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 35,
  viewBox: "0 0 33 35",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_6950_12675)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.6955 34.646H5.36214C2.42881 34.646 0.0288086 32.351 0.0288086 29.546V9.14602C0.0288086 6.34102 2.42881 4.04602 5.36214 4.04602H26.6955C29.6288 4.04602 32.0288 6.34102 32.0288 9.14602V29.546C32.0288 32.351 29.6288 34.646 26.6955 34.646ZM5.36214 7.44602C4.38436 7.44602 3.58436 8.21102 3.58436 9.14602V29.546C3.58436 30.481 4.38436 31.246 5.36214 31.246H26.6955C27.6733 31.246 28.4733 30.481 28.4733 29.546V9.14602C28.4733 8.21102 27.6733 7.44602 26.6955 7.44602H5.36214Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.91791 10.846C7.94014 10.846 7.14014 10.081 7.14014 9.146V2.346C7.14014 1.411 7.94014 0.645996 8.91791 0.645996C9.89569 0.645996 10.6957 1.411 10.6957 2.346V9.146C10.6957 10.081 9.89569 10.846 8.91791 10.846Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.1401 10.846C22.1623 10.846 21.3623 10.081 21.3623 9.146V2.346C21.3623 1.411 22.1623 0.645996 23.1401 0.645996C24.1179 0.645996 24.9179 1.411 24.9179 2.346V9.146C24.9179 10.081 24.1179 10.846 23.1401 10.846Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.91791 27.8461C7.94014 27.8461 7.14014 27.0811 7.14014 26.1461V24.4461C7.14014 23.5111 7.94014 22.7461 8.91791 22.7461C9.89569 22.7461 10.6957 23.5111 10.6957 24.4461V26.1461C10.6957 27.0811 9.89569 27.8461 8.91791 27.8461Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0292 27.8461C15.0515 27.8461 14.2515 27.0811 14.2515 26.1461V24.4461C14.2515 23.5111 15.0515 22.7461 16.0292 22.7461C17.007 22.7461 17.807 23.5111 17.807 24.4461V26.1461C17.807 27.0811 17.007 27.8461 16.0292 27.8461Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.1401 27.8461C22.1623 27.8461 21.3623 27.0811 21.3623 26.1461V24.4461C21.3623 23.5111 22.1623 22.7461 23.1401 22.7461C24.1179 22.7461 24.9179 23.5111 24.9179 24.4461V26.1461C24.9179 27.0811 24.1179 27.8461 23.1401 27.8461Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.91791 21.046C7.94014 21.046 7.14014 20.281 7.14014 19.346V17.646C7.14014 16.711 7.94014 15.946 8.91791 15.946C9.89569 15.946 10.6957 16.711 10.6957 17.646V19.346C10.6957 20.281 9.89569 21.046 8.91791 21.046Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0292 21.046C15.0515 21.046 14.2515 20.281 14.2515 19.346V17.646C14.2515 16.711 15.0515 15.946 16.0292 15.946C17.007 15.946 17.807 16.711 17.807 17.646V19.346C17.807 20.281 17.007 21.046 16.0292 21.046Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.1401 21.046C22.1623 21.046 21.3623 20.281 21.3623 19.346V17.646C21.3623 16.711 22.1623 15.946 23.1401 15.946C24.1179 15.946 24.9179 16.711 24.9179 17.646V19.346C24.9179 20.281 24.1179 21.046 23.1401 21.046Z",
  fill: "white"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_6950_12675"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 34,
  fill: "white",
  transform: "translate(0.0288086 0.645996)"
})))));
export default SvgIconCalendarLg;